import React from 'react'
import MaterialSymbol from '../material-symbol'

const Menu = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="menu" {...props} />
))

Menu.displayName = 'Menu'

export default Menu
